const CHANNEL = 'securspace-email-verification';
const MESSAGE = 'refresh-verification';

export function publishVerification(): void {
  let channel: BroadcastChannel | undefined;
  try {
    channel = new BroadcastChannel(CHANNEL);
    channel.postMessage(MESSAGE);
  } catch {
    // Focus, visibility, online events and polling cover unavailable notifications.
  } finally {
    channel?.close();
  }
}

export function listenForVerification(refresh: () => void): () => void {
  try {
    const channel = new BroadcastChannel(CHANNEL);
    channel.onmessage = event => {
      if (event.data === MESSAGE) refresh();
    };
    return () => channel.close();
  } catch {
    return () => {};
  }
}
